import { useQueryClient } from '@tanstack/react-query';
import { ZfBox, ZfDivider, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { EnrichedClientDto } from '../../api/generated/client';
import { useYwuApp } from '../../contexts/ywu-app-context';
import { useWealthPlanningNavigate } from '../../hooks/useWealthPlanningNavigate';
import { getCountryName } from '../../utils/countryUtils';

interface IProps {
    brUuid?: string;
    client?: EnrichedClientDto;
    isPresentationMode: boolean;
}

export const ClientInfo: FunctionComponent<IProps> = ({ brUuid, client, isPresentationMode }) => {
    const { t } = useTranslation();
    const { activeLanguage: appLanguage } = useYwuApp();
    const queryClient = useQueryClient();
    const { navigateToBase } = useWealthPlanningNavigate();
    const resetActiveClient = () => {
        navigateToBase(); // user might be on the screen that requires active client context, so exit to dashboard
        queryClient.clear();
    };

    return (
        <ZfBox style={{ display: 'flex', gap: 'var(--gap-horizontal-xl)', alignItems: 'center' }}>
            {!isPresentationMode && !brUuid && (
                <>
                    <ZfTextButton size="medium" hierarchy="tertiary" leadingIcon="arrow_back" onClick={resetActiveClient}>
                        {t('exit')}
                    </ZfTextButton>
                    <ZfBox style={{ height: 36 }}>
                        <ZfDivider orientation="vertical" />
                    </ZfBox>
                </>
            )}
            <div className="toolbar__navigation--second-left__client">
                {client?.title} {client?.fullName}
                {client?.mainDomicile?.countryCode && !isPresentationMode ? (
                    <span className="toolbar__navigation--second-left-code">{getCountryName(client.mainDomicile.countryCode, appLanguage)}</span>
                ) : null}
            </div>
            <ZfBox style={{ height: 36 }}>
                <ZfDivider orientation="vertical" />
            </ZfBox>
        </ZfBox>
    );
};
